import { useEffect, useState } from "react";
import { listOrderIntakes } from "@/lib/orderIntakeClient";
import { salesDeskInventoryModels, salesDeskInventoryOrderFromOptions, type SalesDeskInventoryModel } from "./salesDeskInventoryModel";
import { SALES_DESK_SHEDCOR_ORDERS } from "./salesDeskShedcorOrders";

export function useSalesDeskInventoryModels(): {
  models: SalesDeskInventoryModel[];
  sourceLabel: string;
} {
  const [models, setModels] = useState<SalesDeskInventoryModel[]>(() => salesDeskInventoryModels(SALES_DESK_SHEDCOR_ORDERS));
  const [sourceLabel, setSourceLabel] = useState("Documented ShedCor IdeaRoom orders");

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const result = await listOrderIntakes({ source: "idearoom_export", limit: 30 });
      if (cancelled || !result.ok) return;
      const orders = result.data.rows.flatMap((row) => {
        const parsed = salesDeskInventoryOrderFromOptions(row.external_source_id || row.id, row.proposed_options ?? {});
        if (!parsed) return [];
        if (!parsed.supplier.toLowerCase().includes("shed")) return [];
        return [parsed];
      });
      if (orders.length === 0) return;
      setModels(salesDeskInventoryModels(orders).slice(0, 8));
      setSourceLabel("IdeaRoom orders saved for this organization");
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { models, sourceLabel };
}
